module.exports = __webpack_public_path__ + "img/pic1.47c576d1.png";